import { Info } from '@mui/icons-material';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { formatMoney } from '../../../../../../../lib/functions/utils';
import DayDialog from './components/DocumentDialog';

const useStyles = makeStyles(() =>
  createStyles({
    table: {
      width: '100%', // ensure the table fits its container
    },
    tableCell: {
      padding: '2px 6px !important',
      maxWidth: '200px',
      maxHeight: '6px',
      overflow: 'hidden', // Ensure the content doesn't overflow.
      whiteSpace: 'nowrap', // Ensure the text doesn't wrap to the next line.
    },
    tableContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: '10px',
    },
    tableBody: {
      backgroundColor: '#ffffff',
    },
    selectFullWidth: {
      width: '100%',
    },
    selectSmall: {
      width: '200px', // or any other small width
    },
  }),
);

const ReportIncomeDailyTable = (props: any) => {
  const { rows, getIncomeBookReport, generateQuery } = props;
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [loadingDialog, setLoadingDialog] = useState(false);
  const dispatch = useDispatch();

  const handleOpenDialog = async (row: any) => {
    // setLoadingDialog(true);
    // try {
    //   const date = row.date;
    //   const startDate = new Date(date);
    //   const endDate = new Date(date);
    //   startDate.setUTCHours(0, 0, 0, 0);
    //   endDate.setUTCHours(23, 59, 59, 999);
    //   const newQuery = generateQuery({
    //     startDateParam: startDate,
    //     endDateParam: endDate,
    //     showLinesParam: true,
    //   });
    //   const response = await getIncomeBookReport(dispatch, newQuery);
    //   const selectedResponseRow = response.linesByDate.find(
    //     (r: any) => r.date === date,
    //   );
    setSelectedRow(row);
    // } catch (error) {
    //   console.log('Error fetching lines:', error);
    // }
    // setLoadingDialog(false);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  // Calculate totals for summary row (excluding placement columns)
  const calculateTotals = () => {
    return rows.reduce(
      (acc: any, row: any) => ({
        totalConciliated:
          (acc.totalConciliated || 0) + (row.totalConciliated || 0),
        totalPriceIncome:
          (acc.totalPriceIncome || 0) + (row.totalPriceIncome || 0),
        totalArrearIncome:
          (acc.totalArrearIncome || 0) + (row.totalArrearIncome || 0),
        totalComissionIncome:
          (acc.totalComissionIncome || 0) + (row.totalComissionIncome || 0),
        totalExpensesIncome:
          (acc.totalExpensesIncome || 0) + (row.totalExpensesIncome || 0),
        totalDocumentExtensionPriceIncome:
          (acc.totalDocumentExtensionPriceIncome || 0) +
          (row.totalDocumentExtensionPriceIncome || 0),
        totalDocumentExtensionCommissionIncome:
          (acc.totalDocumentExtensionCommissionIncome || 0) +
          (row.totalDocumentExtensionCommissionIncome || 0),
        totalIncome: (acc.totalIncome || 0) + (row.totalIncome || 0),
        totalDocumentResellExpense:
          (acc.totalDocumentResellExpense || 0) +
          (row.totalDocumentResellExpense || 0),
        totalPlaced: (acc.totalPlaced || 0) + (row.totalPlaced || 0),
        totalPlacedNet: (acc.totalPlacedNet || 0) + (row.totalPlacedNet || 0),
        totalDocumentOtherIncome:
          (acc.totalDocumentOtherIncome || 0) +
          (row.totalDocumentOtherIncome || 0),
      }),
      {},
    );
  };

  const totals = calculateTotals();

  return (
    <div style={{ paddingBottom: 100 }}>
      {loadingDialog && <CenteredCircularProgress type="layout" />}
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead style={{ background: '#efefef' }}>
            <TableCell style={{ textAlign: 'right' }}></TableCell>

            <TableCell>Fecha</TableCell>
            <TableCell style={{ textAlign: 'right' }}>Total colocado</TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              Total colocado neto
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>Colocado</TableCell>
            <TableCell style={{ textAlign: 'right' }}>Colocado neto</TableCell>
            <TableCell style={{ textAlign: 'right' }}>Recaudado</TableCell>
            <TableCell style={{ textAlign: 'right' }}>I. Devengo</TableCell>
            <TableCell style={{ textAlign: 'right' }}>I. mora</TableCell>
            {/* <TableCell style={{ textAlign: 'right' }}>Interés prórroga</TableCell> */}

            <TableCell style={{ textAlign: 'right' }}>I. comisión</TableCell>
            <TableCell style={{ textAlign: 'right' }}>I.Gastos</TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              I. Prorroga precio
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>
              I. Prorroga comisión
            </TableCell>
            <TableCell style={{ textAlign: 'right' }}>I. Otros</TableCell>
            <TableCell style={{ textAlign: 'right' }}>I. total</TableCell>
            <TableCell style={{ textAlign: 'right' }}>I. total Acum.</TableCell>
            <TableCell style={{ textAlign: 'right' }}>C. fondo</TableCell>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {rows.map((row: any, rowIndex: any) => (
              // Color on hover
              <TableRow key={rowIndex}>
                <TableCell style={{ padding: 0 }}>
                  <IconButton
                    onClick={() => handleOpenDialog(row)}
                    disabled={loadingDialog}
                  >
                    <Info />
                  </IconButton>
                </TableCell>
                <TableCell className={classes.tableCell}>{row.date}</TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalRealWallet)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalRealWalletNet)}
                </TableCell>

                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalPlaced)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalPlacedNet)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalConciliated)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalPriceIncome)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalArrearIncome)}
                </TableCell>

                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalComissionIncome)}
                </TableCell>

                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalExpensesIncome)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalDocumentExtensionPriceIncome)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalDocumentExtensionCommissionIncome)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalDocumentOtherIncome)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalIncome)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.accumulatedIncome)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(row.totalDocumentResellExpense)}
                </TableCell>
              </TableRow>
            ))}

            {/* Summary Row */}
            <TableRow
              style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}
            >
              <TableCell style={{ padding: 0 }}></TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ fontWeight: 'bold' }}
              >
                TOTAL
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right' }}
              >
                {/* Empty for placement column */}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right' }}
              >
                {/* Empty for placement net column */}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right' }}
              >
                {formatMoney(totals.totalPlaced)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right' }}
              >
                {formatMoney(totals.totalPlacedNet)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalConciliated)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalPriceIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalArrearIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalComissionIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalExpensesIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalDocumentExtensionPriceIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalDocumentExtensionCommissionIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalDocumentOtherIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalIncome)}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              ></TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ textAlign: 'right', fontWeight: 'bold' }}
              >
                {formatMoney(totals.totalDocumentResellExpense)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {selectedRow && openDialog && (
        <DayDialog
          row={selectedRow}
          openDialog={openDialog}
          handleCloseDialog={handleCloseDialog}
        />
      )}
    </div>
  );
};

export default ReportIncomeDailyTable;
